<template>
  <Modal
    :value="show"
    max-width="464px"
    :show-close-button="false"
    persistent
    @input="onModalInput"
  >
    <Typography variant="h-5" class="mb-4 text-left">
      Are you sure you want to delete this resource?
    </Typography>
    <Typography variant="body-1" class="text-left">This action cannot be undone.</Typography>
    <div class="d-flex justify-end mt-6">
      <Button text @click="handleCancel" :disabled="loading" class="text-uppercase mr-2">
        Nevermind
      </Button>
      <Button text @click="handleDelete" :loading="loading" class="text-uppercase">
        Yes, Delete
      </Button>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/generic/Modal.vue";
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";
import ContentService from "@/services/ContentService";

export default {
  name: "DeleteContentDialog",
  components: {
    Modal,
    Typography,
    Button,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  watch: {
    show(val) {
      if (!val) this.loading = false;
    },
  },
  methods: {
    onModalInput(val) {
      if (!val) this.handleCancel();
    },
    handleCancel() {
      this.$emit("update:show", false);
    },
    async handleDelete() {
      if (!this.content) return;
      this.loading = true;
      try {
        await ContentService.deleteContent(this.content.contentId);
        this.$emit("deleted", this.content.contentId);
        this.$emit("update:show", false);
      } catch (error) {
        console.log("Error deleting content", error);
        if (error?.data && error.data.length) {
          this.$emit("in-use", error.data);
          this.$emit("update:show", false);
        } else {
          this.$emit("error", error);
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
